import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Downloads from "../components/PackageDetailsMedia";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

const PackageDetailsMedia = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/downloads-bg.jpg")}
        title="HEALTH CHECK PACKAGES"
        content=""
      />
      <Downloads />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PackageDetailsMedia;
